<p-toast position="top-right" [style]="{'z-index': '999999' }"></p-toast>

<taxi-vehicle-details *ngIf="isVisibleVehicleDetail"
					   [isVisible]="isVisibleVehicleDetail"
					   [_vehicle]="selectedVehicle"
					   [vehiclePool]="vehiclePool"
					   (vehicleAssignmentChanged)="onVehicleAssignmentChanged()"
					   (changedVisibleTaxiVehicleDetailEmit)="changedVisibleTaxiVehicleDetailEmit($event)"></taxi-vehicle-details>

<div class="root-body"
	 [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

	<p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

	<create-taxi-vehicle *ngIf="showVehicleAddSideBar"
				[showDriverAddSideBar]="showVehicleAddSideBar"
				[taxiVehiclesComponent]="this"
				[vehicleToEdit]="vehicleToEdit"
				(changedShowTaxiVehicleAddSideBarEmit)="changedShowTaxiVehicleAddSideBarEmit($event)"></create-taxi-vehicle>

	<div class="card">
		<div class="onboarding-body">
			<div class="onboarding-head mb-4">
				<div class="head-fleft">
					{{ pageTitle }}
				</div>
				<div class="flex flex-row onboarding-head-right">
					<p-button icon="pi pi-plus-circle" label="Add New Vehicle" styleClass="btn-darkblue" class="ml-4" (click)="openDriverAddSideBar()"></p-button>
				</div>
			</div>
			<p-table #ridersGrid
					 [columns]="cols"
					 [value]="gridRiders.Items"
					 [lazy]="true"
					 [selection]="selectedVehicle"
					 dataKey="Id"
                     selectionMode="single"
					 responsiveLayout="scroll"
					 (onLazyLoad)="handleLazyLoad($event)"
					 [loading]="gridRiders.Loading"
					 [paginator]="true"
					 [(first)]="first"
					 [rows]="rowsPerPage"
					 [totalRecords]="totalRecords"
					 [resizableColumns]="true"
					 [columnResizeMode]="'expand'"
					 [showFirstLastIcon]="false"
					 [autoLayout]="true"
					 [styleClass]="'p-datatable-gridlines'"
					 [scrollable]="true"
					 [scrollHeight]="'flex'"
					 [style]="{height: 'calc(100vh - 290px)'}">
				<ng-template pTemplate="caption">
					<div class="flex flex-row sp-header">
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th *ngFor="let col of cols"
							[pSortableColumn]="col.field"
							[pSortableColumnDisabled]="col.disableSort"
							pResizableColumn
							[style.width]="col.width">
							{{col.header}}
							<p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
						</th>
					</tr>
					<tr>
						<ng-container *ngFor="let filter of cols">
							<th class="overflow-unset">
								<ng-container *ngIf="filter.field !== 'Action'">
									<ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
									<input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="riderHeaderSearch[filter.model]"
										   (input)="onChangeHeaderFilterDropDown(filter.field, $event)" />
								</ng-container>
								<ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
									<p-inputNumber inputId="integeronly" placeholder="{{filter.placeholder}}" [(ngModel)]="riderHeaderSearch[filter.model]"
												   (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"> </p-inputNumber>
								</ng-container>
								<ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
									<ng-container *ngIf="filter.take === 'obj'; else dropdown">
										<p-dropdown [showClear]="true" [options]="filter.options" placeholder="{{filter.placeholder}}"
													optionLabel="label" [(ngModel)]="riderHeaderSearch[filter.model]"
													(ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
									</ng-container>
									<ng-template #dropdown>
										<p-dropdown [showClear]="true" [options]="filter.options" placeholder="{{filter.placeholder}}"
													optionLabel="name" optionValue="value" [(ngModel)]="riderHeaderSearch[filter.model]"
													(ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
									</ng-template>
								</ng-container>
								<ng-container *ngIf="filter.model === 'lastActiveType'">
									<p-dropdown [showClear]="true" [options]="lastActiveTypeList" placeholder="Please Select"
												optionLabel="name"
												[(ngModel)]="riderHeaderSearch.lastActiveTypeObj"
												(ngModelChange)="handleHeaderFilterChange(filter.field, $event)"></p-dropdown>
								</ng-container>
								<ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
									<p-calendar [(ngModel)]="riderHeaderSearch[filter.model]"
												[showIcon]="true"
												placeholder="{{filter.placeholder}}"
												[showTime]="true"
												dateFormat="dd M yy"
												(ngModelChange)="onChangeDateAndDropDown($event)" />
								</ng-container>
								</ng-container>
							</th>
						</ng-container>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rider>
					<tr [pSelectableRow]="rider" (click)="openVehicleDetails(rider)">
						<ng-container *ngFor="let col of cols">
							<td *ngIf="col.field === 'Status'" class="ui-resizable-column" (click)="$event.stopPropagation()">
								<span class="onbg-status-col"
									  [style.background-color]="rider.StatusColor"
									  (click)="openSidebarExistingVehicleDetail(rider)">{{rider.Status}}</span>
							</td>
							<td *ngIf="col.field === 'Action'" class="ui-resizable-column" (click)="$event.stopPropagation()">
								<button class="p-button p-button-sm p-button-text" pButton icon="pi pi-pencil" (click)="openEditVehicle(rider)" title="Edit"></button>
							</td>
							<td *ngIf="col.field === 'LastUpdate'" class="ui-resizable-column" [style.color]="rider.LastActiveAtTextColor">
								{{ rider.LastUpdate }}
							</td>
							<td *ngIf="col.field !== 'Status' && col.field !== 'LastUpdate' && col.field !== 'Action'" class="ui-resizable-column">
								{{ rider[col.field] }}
							</td>
						</ng-container>
					</tr>
				</ng-template>
				<ng-template pTemplate="paginatorleft" let-state>
					<div *ngIf="gridRiders.Items !== null && gridRiders.Items.length > 0" style="padding-left: 10px">
						Showing {{first + 1}} to {{first + gridRiders.Items.length}} of {{totalRecords}} entries
					</div>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

